export default {
  methods: {
    emitCloseEvent() {
      this.$emit('close');
    },
  },
};
